import { Routes, Route, Navigate } from 'react-router-dom';
import DoctorDashboard from './DoctorDashboard';

export default function VeterinarianRouter() {
  return (
    <Routes>
      <Route path="/*" element={<DoctorDashboard />} />
      <Route path="dashboard" element={<Navigate to="../" replace />} />
    </Routes>
  );
}
